import { Pipe, PipeTransform } from "@angular/core";
import { LevelConstants } from "../constants/LevelConstants";
@Pipe({
  name: "convertLevel",
})
export class ConvertLevelPipe implements PipeTransform {
  transform(level: string): string {
    const levelMap: Map<string, string> = new Map<string, string>([
      ["e1", LevelConstants.ENTRY_1],
      ["e2", LevelConstants.ENTRY_2],
      ["e3", LevelConstants.ENTRY_3],
      ["l1", LevelConstants.LEVEL_1],
      ["l2", LevelConstants.LEVEL_2],
      ["l3", LevelConstants.LEVEL_3],
    ]);

    const lowercaseLevel: string = level ? level.toLowerCase() : null;
    return levelMap.has(lowercaseLevel) ? levelMap.get(lowercaseLevel) : LevelConstants.NO_LEVEL;
  }
}

